import { makeAutoObservable } from 'mobx';
import apolloClient from 'api/apolloClient';
import { FetchResult } from '@apollo/client';
import { INVITE_TO_ESTORE_ENROLL } from 'api/userService';
import { SEUser, FullUser } from 'types/userService';

export class UserStore {
  // eslint-disable-next-line class-methods-use-this
  async inviteToEStoreEnroll(user: SEUser): Promise<FetchResult<{ inviteToEStoreEnroll: FullUser }>> {
    return apolloClient.mutate<{ inviteToEStoreEnroll: FullUser }>({
      mutation: INVITE_TO_ESTORE_ENROLL,
      fetchPolicy: 'no-cache',
      variables: { user },
    });
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
